// extracted by css-extract-rspack-plugin
export default {"wechatButton":"WeChatButton-module__wechatButton"};